import { Controller } from "@hotwired/stimulus"

// Shows/hides a fade overlay to hint that a container is horizontally scrollable.
// Targets: scroller (the overflow-x-auto element), fade (the gradient overlay)
export default class extends Controller {
  static targets = ["scroller", "fade"]

  connect() {
    this.checkScroll()
  }

  onScroll() {
    this.checkScroll()
  }

  checkScroll() {
    if (!this.hasScrollerTarget || !this.hasFadeTarget) return

    const el = this.scrollerTarget
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 2
    this.fadeTarget.classList.toggle("hidden", atEnd)
  }
}
